// extracted by css-extract-rspack-plugin
export default {"imageTable":"image-table--bpGsPVOZecUYTrZg","card":"card--CRvPnerbj3A2DxU3","addCard":"add-card--VpDkZLpxU28nW1tC","artifact":"artifact--oduHd8jdulYEav4J"};